import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

export interface Carrier {
  id: string;
  name: string;
  code: string;
  website: string;
  trackingUrlTemplate: string;
  active: boolean;
}

export const fetchCarriers = async (): Promise<Carrier[]> => {
  try {
    const carriersRef = collection(db, 'carriers');
    const snapshot = await getDocs(carriersRef);
    
    const carriers: Carrier[] = [];
    snapshot.forEach((doc) => {
      const data = doc.data();
      carriers.push({
        id: doc.id,
        name: data.name,
        code: data.code,
        website: data.website,
        trackingUrlTemplate: data.trackingUrlTemplate,
        active: data.active
      });
    });
    
    // Return only active carriers, sorted by name
    return carriers
      .filter(carrier => carrier.active)
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error('Error fetching carriers:', error);
    // Fallback to hardcoded DHL and FedEx if Firebase fails
    return [
      {
        id: 'dhl',
        name: 'DHL',
        code: 'dhl',
        website: 'dhl.com',
        trackingUrlTemplate: 'https://www.dhl.com/en/express/tracking.html?AWB={trackingNumber}',
        active: true
      },
      {
        id: 'fedex',
        name: 'FedEx',
        code: 'fedex',
        website: 'fedex.com',
        trackingUrlTemplate: 'https://www.fedex.com/apps/fedextrack/?tracknumbers={trackingNumber}',
        active: true
      }
    ];
  }
};

export const generateCarrierTrackingUrl = (carrier: Carrier, trackingNumber: string): string => {
  return carrier.trackingUrlTemplate.replace('{trackingNumber}', trackingNumber);
}; 